<div class="modal-header">
  <h5 class="modal-title">Editar Permissões - {{ user?.name }}</h5>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="dismiss()"
  ></button>
</div>

<div class="modal-body">
  <div *ngIf="isLoading" class="text-center py-4">
    <div class="lds-ring">
      <div></div>
    </div>
  </div>

  <div *ngIf="!isLoading" [formGroup]="permissionsForm">
    <div class="mb-4">
      <label class="fw-bold mb-2">Contas Vinculadas</label>
      <div class="accounts-grid">
        <div *ngFor="let account of accountOptions" class="form-group">
          <label class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              [checked]="selectedAccounts.value.includes(account.id)"
              (change)="toggleAccount(account.id)"
            />
            <span class="custom-control-label">{{ account.name }}</span>
          </label>
        </div>
        <div *ngIf="accountOptions.length === 0" class="form-group">
          Nenhuma conta disponível
        </div>
      </div>
    </div>

    <div class="section-divider"></div>

    <div class="mb-3">
      <label class="fw-bold mb-2">
        Permissões Operador
      </label>
    </div>

    <div class="permissions-grid">
      <div
        class="permission-column"
        *ngFor="let column of permissionColumns"
      >
        <div *ngFor="let item of column" class="form-group">
          <label class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              [formControlName]="item.key"
            />
            <span class="custom-control-label">{{ item.label }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer d-flex justify-content-between align-items-center">
  <label class="custom-switch mb-0">
    <input
      type="checkbox"
      class="custom-switch-input"
      [(ngModel)]="accountAdm"
    />
    <span class="custom-switch-indicator"></span>
    <span class="custom-switch-description">Usuário Administrador</span>
  </label>
  <button
    type="button"
    class="btn btn-primary btn-pill"
    (click)="onSaveClick()"
    [disabled]="isLoading"
  >
    Salvar
  </button>
</div>

<ng-template #requestTOTPCode let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Informe o token de autenticação</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>
  <div class="modal-body">
    <div class="form-group mt-2">
      <p *ngIf="errorMessage.length > 0" class="text-danger">
        {{ errorMessage }}
      </p>
    </div>
    <div class="form-group mb-3">
      <input
        type="text"
        class="form-control"
        id="authToken"
        placeholder="Token"
        [(ngModel)]="validationCode"
        (keyup.enter)="validateTotp()"
      />
      <button
        (click)="pasteTotpCode()"
        class="btn btn-primary btn-block btn-colar h-30 w-30 mx-auto mt-2 mb-1"
      >
        {{ "login.totp.pasteButton" | translate }}
      </button>
    </div>
  </div>
  <div class="modal-footer text-center">
    <button
      type="submit"
      class="btn btn-lg btn-primary btn-pill mx-auto d-block"
      (click)="validateTotp()"
      [disabled]="validatingTotp"
    >
      VALIDAR
    </button>
  </div>
</ng-template>
